module.exports = __webpack_public_path__ + "img/ssBell.bb6e7d0b.svg";